/* SidebarOption.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["isSelected"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, Inline, xcss } from '@atlaskit/primitives';
import React, { useCallback } from 'react';
const _19 = "@media (hover:hover){._1rjn3ht5:hover{background-color:var(--ds-background-selected-hovered)}._13kh1514:active{background-color:var(--ds-background-selected-pressed)}}";
const _18 = "._1di61514:active{background-color:var(--ds-background-selected-pressed)}";
const _17 = "._5wra1oj9{border-left-color:var(--ds-border-selected)}";
const _16 = "._1p3lnqa1{border-left-style:solid}";
const _15 = "._t6vd1bk5{border-left-width:var(--ds-border-width-outline,2px)}";
const _14 = "._syaztmrq{color:var(--ds-text-selected)}";
const _13 = "._bfhka7cx{background-color:var(--ds-background-selected)}";
const _12 = "@media (hover:hover){._1rjn6224:hover{background-color:var(--ds-surface-overlay-hovered)}._13kh18nh:active{background-color:var(--ds-surface-overlay-pressed)}}";
const _11 = "._1di618nh:active{background-color:var(--ds-surface-overlay-pressed)}";
const _10 = "._19it66vy{border:var(--ds-border-width-outline,2px) solid transparent}";
const _9 = "._y3gn1e5h{text-align:left}";
const _8 = "._1wyboxwj{font-size:.875rem}";
const _7 = "._syaz1blv{color:var(--ds-text)}";
const _6 = "._bfhkipex{background-color:var(--ds-surface-overlay)}";
const _5 = "._u5f3xjmg{padding-right:var(--ds-space-200)}";
const _4 = "._19bvxjmg{padding-left:var(--ds-space-200)}";
const _3 = "._n3tdoxav{padding-bottom:var(--ds-space-150)}";
const _2 = "._ca0qoxav{padding-top:var(--ds-space-150)}";
const _ = "._80omtlke{cursor:pointer}";
// Using styled button instead of Pressable so we can use hover media query
const OptionButton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      isSelected
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_80omtlke _ca0qoxav _n3tdoxav _19bvxjmg _u5f3xjmg _bfhkipex _syaz1blv _1wyboxwj _y3gn1e5h _19it66vy _1di618nh _1rjn6224 _13kh18nh", __cmplp.isSelected && "_bfhka7cx _syaztmrq _t6vd1bk5 _1p3lnqa1 _5wra1oj9 _1di61514 _1rjn3ht5 _13kh1514", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  OptionButton.displayName = 'OptionButton';
}
const optionLabelStyles = xcss({
  flex: '2 1 auto',
  maxWidth: '90%',
  wordWrap: 'break-word'
});
const numberOfSelectionsStyles = xcss({
  flex: '1 1 auto',
  minWidth: 'size.100',
  // Reserving space for this component to prevent shifting the sidebar when the first selection is made
  textAlign: 'right'
});
export const SidebarOption = _ref2 => {
  let {
    id,
    isSelected,
    label,
    numberOfSelections,
    onClick
  } = _ref2;
  const handleClick = useCallback(() => {
    onClick(id);
  }, [id, onClick]);
  return /*#__PURE__*/React.createElement(OptionButton, {
    role: "tab",
    "aria-selected": isSelected,
    onClick: handleClick,
    isSelected: isSelected
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    space: "space.100",
    as: "span"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: optionLabelStyles
  }, label), /*#__PURE__*/React.createElement(Box, {
    xcss: numberOfSelectionsStyles
  }, numberOfSelections > 0 && numberOfSelections)));
};